<template>
    <div class="addDelete">
        <div v-if="showWork.length>0" class="sawList" v-for="(item,index) in showWork" :key="index">
            <input type="text" :value="item.name" />
            <input @click="del(index)" type="button" value="删除" />
            <input @click="add()" v-if="index==0" type="button" value="增加" />
        </div>
        <div v-if="showWork.length==0">
            <input @click="add()" type="button" value="增加" />
        </div>
    </div>
</template>

<script>
    import Cookies from "js-cookie";
    export default {
        name:'addDeComponent',
        data(){
            return {
                userInfo:'',
                showWork:[
                    {
                        name:'123456',
                    }
                ]
            }
        },
        methods:{
            add(){
                this.showWork = this.showWork.concat([{name:''}])
            },
            del(index){
                let arrayTemp = this.showWork
                for(let i = 0;i < arrayTemp.length;i++){
                    if(i == index){
                        arrayTemp.splice(i,1)
                    }
                }
                this.showWork = arrayTemp
            }
        },
        created(){
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            this.userInfo = userInfo
        },
    }
</script>

<style scoped lang="less">
    .addDelete{
        width:500px;
        min-height:300px;
        border:solid 1px red;
        margin:0 auto;
        border-radius:3px;
        .sawList{
            display:flex;
            justify-content: flex-start;
            margin-left:10px;
            margin-bottom:20px;
            input{
                margin-right:10px;
            }
            input[type=button]{
                padding:0 10px;
            }
        }
    }
</style>